$(function () {

    // $(".btn-to-get").click(function(e) {
    //     e.preventDefault();
    //     $("html, body").animate({scrollTop: $(".business__form-block").offset().top+"px"});
    // });

    $("input[name=agree]").change(function() {
        var btn = $(this).closest("form").find("[type=submit]");
        if ( $(this).prop("checked") ) {
            btn.removeAttr("disabled");
        }else{
            btn.attr("disabled", true);
        }
    });

    // $("input[type=tel]").inputmask({"mask": "+7(999) 999-9999",showMaskOnHover: false});
    $('input[type=tel]').bind("change keyup input click", function() {
        if (this.value.match(/[^0-9+()]/g)) {
            this.value = this.value.replace(/[^0-9+()]/g, '');
        }
    });

});

function getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar";

    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
}

function hasScrollbar() { // проверка на боковой скролл
    // console.log(document.body.scrollHeight, document.body.clientHeight);
    // return document.body.scrollHeight > document.body.clientHeight;
    // console.log($(document).height() > $(window).height());
    return $(document).height() > $(window).height();
}
